import React from "react";
import { Link } from "react-router-dom";
import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Pagination,
} from "../homePage/Shared/CustomSwiper";

const cleanImage = (url) => {
  if (!url) return "";
  return url.replace(/\[|\]|\(.*?\)/g, "");
};

// Handles multiple possible API shapes:
// 1) item.images = [{ image: "url" }, ...]   (allProductsListing API)
// 2) item.images = ["url", "url", ...]        (array of plain strings)
// 3) item.image = "url"                       (single string field)
// 4) item.thumbnail / item.thumbnail_url       (fallback field names)
const getProductImages = (item) => {
  if (Array.isArray(item?.images) && item.images.length > 0) {
    return item.images
      .map((img) => (typeof img === "string" ? img : img?.image || img?.url || img?.thumbnail))
      .filter(Boolean)
      .map(cleanImage);
  }

  const fallback = item?.image || item?.thumbnail || item?.thumbnail_url;
  return fallback ? [cleanImage(fallback)] : [];
};

function Card({ item }) {
  const images = getProductImages(item);

  return (
    <div className="product-card text-decoration-none">
      
      {/* IMAGE */}
      <div className="product-image-wrapper">
        <Link to={`/shop/${item?.slug}`} className="product-img-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            className="product-swiper"
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt={item?.name}
                  loading="lazy"
                  className="product-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Link>
      </div>

      {/* DETAILS */}
      <div className="product-details">
        <h6 className="product-title">{item?.name}</h6>

        {item?.short_description && (
          <p className="product-short-desc">
            {item.short_description}
          </p>
        )}
      </div>
    </div>
  );
}

export default Card;